import { Outlet, Navigate } from "react-router-dom";

import { useAuth } from "../../hooks/useAuth";

const ProtectedRoutes = () => {
  const { isAuthenticated, isVerified } = useAuth();

  // Block stakeholder-only users from accessing regular dashboard
  const stakeholderToken = localStorage.getItem("stakeholderToken");
  const regularToken = localStorage.getItem("authToken");

  if (stakeholderToken && !regularToken) {
    return <Navigate to="/v2/auth/login" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/v2/auth/login" />;
  }

  if (!isVerified) {
    return <Navigate to="/v2/auth/verify-email-sent" />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
